
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[...url]",
      function () {
        return require("private-next-pages/category/[...url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[...url]"])
      });
    }
  